import { LANDING_LANDING_SET_DATA } from 'rebook/apps/landing/constants';


const initialState = {
  noveltyBookset: null,
  businessBookset: null,
  freeBooksBookset: null,
  latestBooksets: null,
  audioBookset: null,
  niches: null,
  genres: null,
};

export default function landing(state = initialState, action) {
  switch (action.type) {
    case LANDING_LANDING_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
